<template>
  <Loader :show="loading" />
  <section class="section-remember-password">
    <div class="container-content">
      <div class="card-wrapper">
        <div class="flex justify-end mb-3 w-full">
          <LanguageSelector />
        </div>
        <div class="logo-wrapper">
          <Logo brand="one-vision-shop" class="logo-img" />
        </div>
        <div class="form-content">
          <h2 class="form__title">{{ $t("has_olvidado_tu_contrasena") }}</h2>
          <template v-if="sent">
            <div class="success-block">
              <img
                src="@/assets/login/icon-check-circle.svg"
                alt=""
                class="success-icon"
                aria-hidden
              />
              <p class="success-message" v-if="emailCliente">
                {{ $t("revisa_el_correo_en") }}
                <strong class="email-highlight">{{ emailCliente }}</strong>
              </p>
              <p class="success-message" v-else>
                {{ $t("si_el_cliente_indicado_existe_recibira_email_instrucciones") }}
              </p>
              <router-link to="/login" class="primary-button primary-button--center">
                {{ $t("volver_al_inicio_de_sesion") }}
              </router-link>
            </div>
          </template>
          <template v-else>
            <p class="form__text">{{ $t("por_favor_indica_tu_numero_de_cliente") }}</p>
            <p class="form__text">{{ $t("recibiras_mail_con_contrasena_temporal") }}</p>
            <div class="form__input">
              <label for="client">{{ $t("cliente") }}*</label>
              <input
                class="credentials"
                type="text"
                autocapitalize="none"
                placeholder=""
                autocomplete="mail"
                id="client"
                v-model="cliente"
              />
            </div>
            <button
              type="submit"
              class="primary-button"
              @click.prevent="cambioPassword"
              :disabled="cliente === '' || loading"
            >
              {{ $t("enviar") }}
            </button>
            <div class="form__link">
              <img src="@/assets/login/icon-arrow-full-left.svg" alt="" aria-hidden />
              <router-link to="/login" class="link-return">{{
                $t("volver_al_inicio_de_sesion")
              }}</router-link>
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import LanguageSelector from "@/components/atoms/LanguageSelector.vue";
import Loader from "@/components/atoms/Loader.vue";
import Logo from "@/components/theme/ui/Logo.vue";

const authStore = useAuthStore();

const cliente = ref("");
const sent = ref(false);
const emailCliente = ref("");
const loading = ref(false);

async function cambioPassword() {
  loading.value = true;
  try {
    const result = await authStore.PedirContrasena({ cliente: cliente.value });
    sent.value = true;
    emailCliente.value = result?.sEmailCliente || "";
  } finally {
    loading.value = false;
  }
}
</script>

<style lang="scss" scoped>
.section-remember-password {
  @apply overflow-hidden relative bg-cover bg-no-repeat min-h-screen flex items-center;
  background-image: url("../../../assets/login/Optico_estandar.png");
  background-position: 75% center;
  background-size: cover;
}

.container-content {
  @apply w-full max-w-[1920px] mx-auto px-4 sm:px-6 md:px-8;
}

.card-wrapper {
  @apply mx-auto p-6 sm:p-8 md:p-10 bg-white flex flex-col items-center w-full max-w-[500px] shadow-lg;
}

.logo-wrapper {
  @apply mb-6;
}

.logo-img {
  @apply h-12 sm:h-14 md:h-16 w-auto;
}

.form-content {
  @apply w-full flex flex-col items-center;
}

.form__title {
  @apply text-xl sm:text-2xl md:text-3xl font-bold text-center w-full mb-4;
}

.form__text {
  @apply text-sm sm:text-base text-center w-full mb-2 last:mb-6;
}

.form__input {
  @apply w-full max-w-[396px] mx-auto mb-6;

  label {
    @apply block text-sm font-bold mb-2 text-rst_secondary;
  }

  .credentials {
    @apply w-full px-3 py-2.5 border border-gray-300 text-base;
  }
}

.success-block {
  @apply flex flex-col items-center w-full py-4;
}

.success-icon {
  @apply w-14 h-14 mb-4 flex-shrink-0;
}

.success-message {
  @apply text-base sm:text-lg text-center mb-6 max-w-md;
}

.email-highlight {
  @apply font-semibold text-primary break-all;
}

.primary-button--center {
  @apply self-center;
}

.primary-button:disabled {
  @apply opacity-50 cursor-not-allowed;
}

.form__link {
  @apply mt-6 flex gap-2 items-center justify-center;

  img {
    @apply w-4 h-4;
  }
}

.link-return {
  @apply text-sm font-bold text-rst_secondary hover:text-primary_dark transition-colors;
}
</style>
